import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';

const valueStats = [
  { label: '每日更新', value: '1000+', unit: '部', icon: 'ri-refresh-line' },
  { label: '累计用户', value: '500', unit: '万+', icon: 'ri-user-heart-line' },
  { label: '视频内容', value: '10', unit: '万+', icon: 'ri-movie-line' },
  { label: '高清画质', value: '4K', unit: '', icon: 'ri-4k-line' },
];

function BrandIntro() {
  return (
    <section className="pb-10 md:pb-14">
      <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-6">关于黑桃视频</h1>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-10">
        <div>
          <h2 className="text-lg md:text-xl font-heading font-semibold text-foreground-900 mb-4">品牌介绍</h2>
          <div className="text-sm md:text-base text-foreground-600 leading-relaxed space-y-4">
            <p>
              黑桃视频成立于2020年，是国内领先的免费视频内容聚合和推荐平台。我们致力于为广大用户提供最新、最全、最高清的视频内容服务，涵盖电影、电视剧、综艺节目、动漫番剧、纪录片和短剧等多个领域。
            </p>
            <p>
              黑桃视频始终坚持"用户至上、内容为王"的理念，通过先进的技术和优质的服务，让每一位用户都能享受到流畅、高清的视频观看体验。我们的内容团队每天精选最新最热的视频内容，确保用户不错过任何精彩。
            </p>
            <p>
              作为西瓜视频免费、西瓜视频高清全集在线观看的首选平台，黑桃视频以不缓冲流畅播放、每日更新的电影大全赢得了广大用户的信赖和喜爱。无论是热门大片还是小众佳作，都能在黑桃视频找到。
            </p>
          </div>
        </div>

        <div className="rounded-lg overflow-hidden aspect-video">
          <img
            src="https://readdy.ai/api/search-image?query=Modern%20Chinese%20media%20company%20office%20with%20large%20video%20screens%20displaying%20movies%2C%20bright%20open%20workspace%2C%20creative%20atmosphere%2C%20warm%20lighting%2C%20contemporary%20design%2C%20professional%20environment%2C%20clean%20aesthetic&width=800&height=450&seq=heitao-about-01&orientation=landscape"
            alt="黑桃视频办公室"
            title="黑桃视频 - 办公环境"
            className="w-full h-full object-cover"
          />
        </div>
      </div>
    </section>
  );
}

function StatsSection() {
  return (
    <section className="py-10 md:py-14 bg-background-100 rounded-lg px-6 md:px-10 mb-10">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
        {valueStats.map((stat) => (
          <div key={stat.label} className="text-center">
            <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
              <i className={`${stat.icon} text-xl`}></i>
            </div>
            <div className="flex items-baseline justify-center gap-0.5">
              <span className="text-2xl md:text-3xl font-heading font-bold text-primary-600">{stat.value}</span>
              <span className="text-sm text-foreground-500">{stat.unit}</span>
            </div>
            <p className="text-xs md:text-sm text-foreground-500 mt-1">{stat.label}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

function ReputationSection() {
  const testimonials = [
    {
      content: '黑桃视频真的太棒了！画质高清不卡顿，每天都有新内容更新，我每天都在上面追剧看电影，强烈推荐给所有喜欢看视频的朋友。',
      author: '张先生',
      role: '资深影迷',
    },
    {
      content: '朋友推荐的黑桃视频，没想到内容这么全。西瓜视频和丝瓜视频的热门内容这里都能找到，播放流畅不用等缓冲，体验非常好。',
      author: '李女士',
      role: '追剧达人',
    },
    {
      content: '作为纪录片爱好者，黑桃视频的高清纪录片资源让我非常满意。分类清晰，更新及时，画质好，而且完全免费，是良心平台。',
      author: '王同学',
      role: '纪录片爱好者',
    },
    {
      content: '一直在找能流畅看高清视频的平台，黑桃视频完美满足了我的需求。界面简洁好用，内容更新快，最重要的是不卡顿，强烈推荐。',
      author: '刘先生',
      role: '视频创作者',
    },
  ];

  return (
    <section className="pb-10 md:pb-14">
      <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-2">用户口碑</h2>
      <p className="text-sm text-foreground-500 mb-6">来自真实用户的评价和反馈</p>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
        {testimonials.map((t, idx) => (
          <div key={idx} className="p-5 md:p-6 rounded-lg bg-background-100 border border-background-200/70">
            <div className="flex items-center gap-1 mb-3">
              {Array.from({ length: 5 }).map((_, i) => (
                <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
              ))}
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">{t.content}</p>
            <div className="flex items-center gap-3">
              <div className="w-9 h-9 rounded-full bg-primary-100 flex items-center justify-center text-primary-600 font-heading font-bold text-sm">
                {t.author.charAt(0)}
              </div>
              <div>
                <p className="text-sm font-medium text-foreground-800">{t.author}</p>
                <p className="text-xs text-foreground-400">{t.role}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

function ContactSection() {
  const [formStatus, setFormStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = formData.get('phone_alt') as string;
    if (honeypot && honeypot.trim() !== '') {
      setFormStatus('success');
      form.reset();
      return;
    }

    try {
      const formUrl = 'https://readdy.ai/api/form/d9n171m8mbnljin59so0';
      const response = await fetch(formUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(
          Array.from(formData.entries())
            .filter(([key]) => key !== 'phone_alt')
            .map(([key, value]) => [key, value.toString()])
        ).toString(),
      });

      const responseText = await response.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (response.ok && parsed?.code === 'OK') {
        setFormStatus('success');
        form.reset();
      } else {
        throw new Error(parsed?.meta?.message || parsed?.message || '提交失败，请稍后再试');
      }
    } catch (err: unknown) {
      setFormStatus('error');
      setFormError(err instanceof Error ? err.message : '提交失败，请稍后再试');
    }
  };

  return (
    <section className="pb-10 md:pb-14">
      <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-2">联系我们</h2>
      <p className="text-sm text-foreground-500 mb-6">如果您有任何问题或建议，欢迎通过以下方式联系我们</p>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <div className="space-y-5">
          <div className="flex items-start gap-4">
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 flex-shrink-0">
              <i className="ri-mail-line"></i>
            </div>
            <div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">电子邮件</h3>
              <p className="text-sm text-foreground-500">contact@heitao-video.com</p>
            </div>
          </div>
          <div className="flex items-start gap-4">
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 flex-shrink-0">
              <i className="ri-phone-line"></i>
            </div>
            <div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">客服电话</h3>
              <p className="text-sm text-foreground-500">400-888-6666</p>
            </div>
          </div>
          <div className="flex items-start gap-4">
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 flex-shrink-0">
              <i className="ri-map-pin-line"></i>
            </div>
            <div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">公司地址</h3>
              <p className="text-sm text-foreground-500">北京市朝阳区望京SOHO T2 12层</p>
            </div>
          </div>
          <div className="flex items-start gap-4">
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 flex-shrink-0">
              <i className="ri-time-line"></i>
            </div>
            <div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">工作时间</h3>
              <p className="text-sm text-foreground-500">周一至周五 9:00 - 18:00</p>
            </div>
          </div>
        </div>

        <div>
          <form onSubmit={handleSubmit} data-readdy-form className="space-y-4" id="contact-form">
            <div>
              <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-700 mb-1.5">
                您的姓名 <span className="text-primary-500">*</span>
              </label>
              <input
                type="text"
                id="contact-name"
                name="name"
                required
                className="w-full px-4 py-2.5 text-sm border border-background-300 rounded-lg bg-background-50 focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-primary-300 transition-colors"
                placeholder="请输入您的姓名"
              />
            </div>
            <div>
              <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-700 mb-1.5">
                电子邮箱 <span className="text-primary-500">*</span>
              </label>
              <input
                type="email"
                id="contact-email"
                name="email"
                required
                className="w-full px-4 py-2.5 text-sm border border-background-300 rounded-lg bg-background-50 focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-primary-300 transition-colors"
                placeholder="请输入您的邮箱"
              />
            </div>
            <div>
              <label htmlFor="contact-subject" className="block text-sm font-medium text-foreground-700 mb-1.5">
                主题
              </label>
              <input
                type="text"
                id="contact-subject"
                name="subject"
                className="w-full px-4 py-2.5 text-sm border border-background-300 rounded-lg bg-background-50 focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-primary-300 transition-colors"
                placeholder="请输入主题"
              />
            </div>
            <div>
              <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-700 mb-1.5">
                留言内容 <span className="text-primary-500">*</span>
              </label>
              <textarea
                id="contact-message"
                name="message"
                required
                rows={4}
                maxLength={500}
                className="w-full px-4 py-2.5 text-sm border border-background-300 rounded-lg bg-background-50 focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-primary-300 transition-colors resize-none"
                placeholder="请输入您的留言内容（500字以内）"
              />
            </div>

            <div className="spam-guard">
              <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
            </div>

            <button
              type="submit"
              className="w-full py-3 bg-primary-500 text-background-50 rounded-lg font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              发送留言
            </button>

            {formStatus === 'success' && (
              <p className="text-sm text-green-600 text-center">感谢您的留言，我们会尽快回复！</p>
            )}
            {formStatus === 'error' && (
              <p className="text-sm text-primary-600 text-center">{formError || '提交失败，请稍后再试'}</p>
            )}
          </form>
        </div>
      </div>
    </section>
  );
}

export default function AboutPage() {
  const orgLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '黑桃视频',
    url: typeof window !== 'undefined' ? window.location.origin : '',
    description: '黑桃视频 - 免费在线观看高清电影、电视剧、综艺、动漫、纪录片，西瓜视频免费、西瓜视频高清全集在线观看不缓冲电影大全',
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '400-888-6666',
      contactType: 'customer service',
      availableLanguage: 'Chinese',
      email: 'contact@heitao-video.com',
    },
    address: {
      '@type': 'PostalAddress',
      addressLocality: '北京',
      addressRegion: '朝阳区',
      streetAddress: '望京SOHO T2 12层',
    },
  };

  const webPageLd = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于黑桃视频',
    description: '了解黑桃视频的品牌故事、用户口碑和联系方式。黑桃视频提供西瓜视频免费、西瓜视频高清全集在线观看服务。',
    url: typeof window !== 'undefined' ? window.location.href : '',
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(orgLd)}</script>
      <script type="application/ld+json">{JSON.stringify(webPageLd)}</script>
      <Navbar />
      <main className="min-h-screen pt-16">
        <div className="max-w-[1440px] mx-auto px-4 md:px-6 py-6">
          <Breadcrumb items={[{ label: '关于我们' }]} />

          <BrandIntro />
          <StatsSection />
          <ReputationSection />
          <ContactSection />
        </div>
      </main>
      <Footer />
    </>
  );
}